import { CAMPAIGN } from "../../pool";
import axiom from "../../utils/axiom";

export const listCampaignsApi = async (clientId, role) => {
  const params = new URLSearchParams();
  if (clientId && clientId !== "all") {
    params.set("clientId", clientId);
  }
  if (role) {
    params.set("role", role);
  }
  const query = params.toString() ? `?${params.toString()}` : "";
  return await axiom.get(`${CAMPAIGN.base}${CAMPAIGN.paths.list}${query}`);
};

export const createCampaignApi = async (payload) => {
  return await axiom.post(`${CAMPAIGN.base}${CAMPAIGN.paths.create}`, payload);
};

export const getCampaignByIdApi = async (id) => {
  return await axiom.get(`${CAMPAIGN.base}${CAMPAIGN.paths.get}${id}`);
};

export const updateCampaignApi = async (id, payload) => {
  return await axiom.put(`${CAMPAIGN.base}${CAMPAIGN.paths.update}${id}`, payload);
};

export const deleteCampaignApi = async (id) => {
  return await axiom.delete(`${CAMPAIGN.base}${CAMPAIGN.paths.delete}${id}`);
};

export const getCampaignAnalyticsApi = async (id) => {
  return await axiom.get(`${CAMPAIGN.base}${CAMPAIGN.paths.analytics(id)}`);
};
